import { useEffect, useState } from 'react';
import { DEFAULT_LABELS, getAddressFieldLabels, normalizeAddressFieldLabels } from '../utils/addressStrings';

const useAddressFieldLabels = (country, language, strings = null) => {
  const [labels, setLabels] = useState(DEFAULT_LABELS);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    if (strings && typeof strings === 'object') {
      setLabels(normalizeAddressFieldLabels(strings));
      setIsLoading(false);
      return () => {
        isMounted = false;
      };
    }

    setIsLoading(true);
    getAddressFieldLabels({ country, language }).then((resolvedLabels) => {
      if (isMounted) {
        setLabels(resolvedLabels);
        setIsLoading(false);
      }
    });

    return () => {
      isMounted = false;
    };
  }, [country, language, strings]);

  return { labels, isLoading };
};

export default useAddressFieldLabels;
